import React, { useEffect, useState } from "react";
import "./Gallery.css";

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [galleryItems, setGalleryItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    async function load() {
      const fallbackItems = [
        { id: 1, label: "Smile Transformation", image: '/images/or_01.jpeg', category: "gallery" },
        { id: 2, label: "Before & After", image: '/images/or_02.jpeg', category: "gallery" },
        { id: 3, label: "Dental Care", image: '/images/or_03.jpeg', category: "gallery" },
        { id: 4, label: "Healthy Smile", image: '/images/or_04.jpeg', category: "gallery" },
        { id: 5, label: "Happy Patients", image: '/images/or_05.jpeg', category: "gallery" },
        { id: 6, label: "Clinic Environment", image: '/images/or_06.jpeg', category: "gallery" },
        { id: 7, label: "Modern Equipment", image: '/images/or_07.jpeg', category: "gallery" },
        { id: 8, label: "Professional Care", image: '/images/or_08.jpeg', category: "gallery" },
        { id: 9, label: "Teeth Whitening", image: '/images/or_09.jpeg', category: "gallery" },
        { id: 10, label: "Orthodontics", image: '/images/or_10.jpeg', category: "gallery" }
      ];

      try {
        const res = await fetch("https://bokundaradentalclinic.com/api/gallery-list.php");
        const data = await res.json();

        let items = (data.images || []).map((img, index) => ({
          id: index + 1,
          label: "Gallery",
          image: img.url,
          file: img.file,
          category: "gallery",
        }));

        if (items.length === 0) {
          items = fallbackItems;
        }

        if (isMounted) setGalleryItems(items);
      } catch (e) {
        console.error("Gallery load error:", e);
        if (isMounted) setGalleryItems(fallbackItems);
      } finally {
        if (isMounted) setLoading(false);
      }
    }

    load();
    return () => { isMounted = false; };
  }, []); // runs once on mount [web:172]

  return (
    <section className="gallery-section">
      <div className="container">
        <div className="gallery-header">
          <h2 className="gallery-title">Our Gallery</h2>
          <p className="gallery-subtitle">
            Explore our clinic, facilities, and successful treatments
          </p>
        </div>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <div className="gallery-grid">
            {galleryItems.map((item) => (
              <div
                key={item.id}
                className="gallery-item"
                onClick={() => setSelectedImage(item)}
              >
                <div className="gallery-image-wrapper">
                  <img
                    src={item.image}
                    alt={item.label}
                    className="gallery-image"
                    loading="lazy"
                  />
                  <div className="gallery-overlay">
                    <div className="overlay-content">
                      <p className="overlay-label">{item.label}</p>
                      <button className="view-btn" type="button">View</button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {selectedImage && (
        <div className="modal-overlay" onClick={() => setSelectedImage(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setSelectedImage(null)}>
              ✕
            </button>
            <img
              src={selectedImage.image}
              alt={selectedImage.label}
              className="modal-image"
            />
            <p className="modal-label">{selectedImage.label}</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
